angular.module('unergie.main')
.controller('slimpaySignContractModalCtrl', ($scope, $uibModalInstance, ApiUser, AlertManager, ErrorCatcher, idDraft) => {
    $scope.idDraft = idDraft

    const handleEvent = (e) => {
        console.log('order_reference', e.detail)
    }

    const addListeners = () => {
        window.addEventListener('slimpayOrderReference', handleEvent, false)
    }

    const activate = () => {
        $scope.fetchingRedirectUrl = true
        return ApiUser.generateMandate({ idDraft }).$promise.then((redirect) => {
            console.log('redirect', redirect)
            $scope.redirectUrl = redirect.redirectUrl
            addListeners()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingRedirectUrl = false
        })
    }

    // NOT WORKING
    // new MutationObserver((mutations) => {
    //     mutations.some((mutation) => {
    //         if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
    //             console.log(mutation)
    //             console.log('Old src: ', mutation.oldValue)
    //             console.log('New src: ', mutation.target.src)
    //             return true
    //         }
    //         return false
    //     })
    // }).observe(document.body, {
    //     attributes: true,
    //     attributeFilter: ['src'],
    //     attributeOldValue: true,
    //     characterData: false,
    //     characterDataOldValue: false,
    //     childList: true,
    //     subtree: true,
    // })

    activate()

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()
})
